const apiUrl = 'https://research.pecher.co/survey/v1';
// const apiUrl = 'http://localhost:9000/survey/v1';

export { apiUrl };
